import React from 'react';
import './index.css';

export default class DataBox extends React.Component{
    render(){
        const data = this.props.data

        return(
            <div className="data-box">
                <p className="box-name">{data.name}</p>
                <hr/>
                <p className="box-data">{data.data}</p>
                <p className="box-raise">{data.change}%</p>
            </div>
        );
    }
}